import React, { ComponentType } from 'react';
import { useAuthN } from 'hooks/auth/subscriptions';
import { Provider } from 'app-types';

export interface WithAuthNProps {
  authenticated: boolean;
  authTypes: Provider[];
}

interface AuthNWrapperProps {
  authTypes?: Provider[];
}

function AuthNWrapper<P extends WithAuthNProps>(
  Component: ComponentType<P>,
): ComponentType<Omit<P, keyof WithAuthNProps> & AuthNWrapperProps> {
  const Wrapper = ({
    authTypes = [],
    ...rest
  }: Omit<P, keyof WithAuthNProps> & AuthNWrapperProps) => {
    const authenticated = useAuthN(authTypes);
    return (
      <Component
        {...(rest as P)}
        authenticated={authenticated}
        authTypes={authTypes}
      />
    );
  };

  Wrapper.displayName = `AuthNWrapper(${Component.displayName || Component.name || 'Component'})`;

  return Wrapper;
}

export default AuthNWrapper;
